module.exports = __webpack_public_path__ + "img/lofi_prototype.9dc824f7.png";